export enum DefectTableFeature {
    ADD = 'add',
    DELETE = 'delete',
}